module.exports = __webpack_public_path__ + "img/na.48da37b9.svg";